let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8iQSy")).then(() => parcelRequire('9c7ho'));